import React from 'react';
import Styles from '../assets/css/layouts/content.module.scss';
// import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import CompanyAdd from '../components/company/CompanyAdd';
import { Outlet } from 'react-router-dom';

const Content = () => {

  const toggleValue = useSelector(state => state.toggle.toggle);

  return (
    <div className={`${Styles.content} ${toggleValue ? Styles.active : ""}`}>
      <div className={`${Styles.container}`}>
        <Outlet />
      </div>
    </div>
  )
}

export default Content
